import { match, P } from 'ts-pattern';
import type { IxcRegistrationV1AccountCheck } from '@interxfi/types/generated/api';
import { determineIfRegistrationOutcomeRequiresAction } from '../../check/registration-check-helpers';

export function getAccountCheckOutcome(check: IxcRegistrationV1AccountCheck) {
  return match(check.checkType)
    .with({ clearingAutomatedApproval: P.not(P.nullish) }, (c) => c.clearingAutomatedApproval?.evidence?.outcome)
    .with({ clearingManualApproval: P.not(P.nullish) }, (c) => c.clearingManualApproval?.evidence?.outcome)
    .with({ programApproval: P.not(P.nullish) }, (c) => c.programApproval?.evidence?.outcome)
    .exhaustive();
}

export function getAccountCheckTimestamp(check: IxcRegistrationV1AccountCheck) {
  return match(check.checkType)
    .with({ clearingAutomatedApproval: P.not(P.nullish) }, (c) => c.clearingAutomatedApproval?.evidence?.timestamp)
    .with({ clearingManualApproval: P.not(P.nullish) }, (c) => c.clearingManualApproval?.evidence?.timestamp)
    .with({ programApproval: P.not(P.nullish) }, (c) => c.programApproval?.evidence?.timestamp)
    .exhaustive();
}

export function determineAccountCheckRequiresAction(check: IxcRegistrationV1AccountCheck) {
  return determineIfRegistrationOutcomeRequiresAction(getAccountCheckOutcome(check));
}
